export enum TranslationSources {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE'
}
